import { render, staticRenderFns } from "./other-patients-screen-one.vue?vue&type=template&id=26e16edb&"
import script from "./other-patients-screen-one.vue?vue&type=script&lang=js&"
export * from "./other-patients-screen-one.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports